export const getHeadersForDisplay = (): string[] => {
  return [
    "Round name",
    "ESOP, %",
    "Pre-money",
    "Round",
    "Post-money",
    null,
    "Investment (Companies)",
    "Investment (Amount)",
    "Holding (%)",
    null,
    "Exit. comp",
    "Comp. value",
    "Proceeds",
    null,
    "Write-off (Companies)",
    null,
    "Investment (Total)",
    "Proceed (Total)",
    "MOIC (Total)",
  ];
};


export const getHeadersForLogic = (): string[] => {
  return [
    "Round name",
    "ESOP, %",
    "Pre-money",
    "Round",
    "Post-money",
    'empty',
    "Investment (Companies)",
    "Investment (Amount)",
    "Holding (%)",
    'empty(1)',
    "Exit. comp",
    "Comp. value",
    "Proceeds",
    'empty(2)',
    "Write-off (Companies)",
    'empty(3)',
    "Investment (Total)",
    "Proceed (Total)",
    "MOIC (Total)",
  ];
};
